import { useEffect, useRef } from "react";
import Navbar from "../components/anreal/Navbar";
import Hero from "../components/anreal/Hero";
import StatsStrip from "../components/anreal/StatsStrip";
import About from "../components/anreal/About";
import VideoSection from "../components/anreal/VideoSection";
import Amenities from "../components/anreal/Amenities";
import Gallery from "../components/anreal/Gallery";
import Sustainability from "../components/anreal/Sustainability";
import Tipologias from "../components/anreal/Tipologias";
import Location from "../components/anreal/Location";
import ContactForm from "../components/anreal/ContactForm";
import Footer from "../components/anreal/Footer";
import { useReveal } from "../lib/reveal";

export default function Landing() {
  useReveal();
  const contactRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    document.title = "ANREÁL Residence — Condomínio Privado em Cantanhede";
  }, []);

  const goContact = () => {
    document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const goVideo = () => {
    document.getElementById("video")?.scrollIntoView({ behavior: "smooth", block: "start" });
    // Give scroll a moment then start video with sound
    setTimeout(() => videoRef.current?.play(), 700);
  };

  const selectTipologia = (code, pisoId) => {
    contactRef.current?.setTipologia(code, pisoId);
    goContact();
  };

  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero onCta={goContact} onWatchVideo={goVideo} />
      <StatsStrip />
      <About />
      <VideoSection ref={videoRef} />
      <Amenities />
      <Gallery />
      <Sustainability />
      <Tipologias onSelect={selectTipologia} />
      <Location />
      <ContactForm ref={contactRef} />
      <Footer />
    </main>
  );
}
